var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',[_c('polygon',{attrs:{"viewbox":"0 0 100 100","stroke":"purple","fill-opacity":"0","stroke-width":"6","points":"50 15, 100 100, 0 100"}})])}
var staticRenderFns = []

export { render, staticRenderFns }